import {useAppEnvStore} from '../../stores/app/appEnvStore';
import AxiosService from '../app/axiosService';
import appNotificationService from './appNotificationService';
import appConsoleService from './appConsoleService';

class AppEnvService {

  getStoreInstance() {
    if (!this.store) {
      this.store = useAppEnvStore()
      this.load().then(()=> appConsoleService.info('AppEnvService', "Env variables loaded"))
    }
    return this.store
  }

  /**
   * Load env variables
   */
  async load() {

    const store = this.getStoreInstance()
    store.setStatus('loading')
    try {
      let response = await AxiosService.get("/appEnv/load");
      store.load(response.data.env)
      store.setStatus('loaded')
    }catch(error) {
      // Backend injoignable : on marque 'error' pour que noLanding.vue affiche
      // « Maintenance en cours » plutôt que « Page d'accueil non configurée ».
      store.setStatus('error')
      appNotificationService.pushError(error);
    }
  }

  getEnv(name) {
    return this.getStoreInstance().getEnv(name)
  }

  getAppCode() {
    return this.getStoreInstance().getEnv('APP_CODE')
  }
}

export default new AppEnvService()

